import { getTreeId } from "routes/schedule/lib/getTreeId"

export function moveScheduleToGroup(scheduleId, groupId, tree = getTreeId(groupId) ?? getTreeId(scheduleId)) {
    const id = scheduleId.split("!").at(-1)
    const to = tree ? `${groupId.split("!").at(-1)}~${tree}` : `${groupId.split("!").at(-1)}`
    return `${to}!${id}`
}
